













import { PropType, defineComponent } from '@vue/composition-api';
import { Issue } from '../../dataType';

export default defineComponent({
  props: {
    issue: {
      type: Object as PropType<Issue>,
      required: true
    }
  }
});
